"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthError = void 0;
const tslib_1 = require("tslib");
const auth_failed_error_1 = require("./auth.failed.error");
const unexpected_client_error_1 = require("./unexpected.client.error");
tslib_1.__exportStar(require("./auth.failed.error"), exports);
tslib_1.__exportStar(require("./client.error"), exports);
tslib_1.__exportStar(require("./exchange.failed.error"), exports);
tslib_1.__exportStar(require("./refresh.failed.error"), exports);
tslib_1.__exportStar(require("./unexpected.client.error"), exports);
const createAuthError = (response) => {
    switch (response.errorCode) {
        case auth_failed_error_1.AuthResponseErrorCode.AUTH_MAX_ERROR_TRIES:
        case auth_failed_error_1.AuthResponseErrorCode.AUTH_FAILED:
        case auth_failed_error_1.AuthResponseErrorCode.INVALID_CREDENTIALS:
        case auth_failed_error_1.AuthResponseErrorCode.PENDING_USER:
        case auth_failed_error_1.AuthResponseErrorCode.TOTP_FAILURE:
            return new auth_failed_error_1.AuthFailedError(response);
        case 'UNKNOWN_ERROR':
        default:
            return new unexpected_client_error_1.UnexpectedClientError(response);
    }
};
exports.createAuthError = createAuthError;
//# sourceMappingURL=index.js.map